import type { FaireProductEntity } from "../../entity_types/product";

export const p_etaqmk8utp: FaireProductEntity = {
  token: "p_etaqmk8utp",
  type: "product",
  name: 'Angle Cut Goblet-8.5"H(12oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/5b691b3454b0261478729cf2dded7dc876f4a8e31e81f7102e6d101660162beb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f63456a0dd756cdcf40d5feccd1cdfba21009dd69827ac983ff788107482b9f5.jpeg",
    "https://cdn.faire.com/fastly/47862f671703fdc13a18c2fb6f43d074ebd37eb57af2a34cb7132b5d42af2d35.jpeg",
    "https://cdn.faire.com/fastly/8e015014e0cca8875ba60107ad3ecbe22235922da57f16e3cfbd26388f92fa1f.jpeg",
    "https://cdn.faire.com/fastly/54946f86db8cdf23c7924bf96940d2ae476d3882d60439e884f62f4f62f98970.jpeg",
    "https://cdn.faire.com/fastly/3f355a3694545ad6db7c03082f7b278ec5469736dc3eeee180d060e0e1285cd8.jpeg",
    "https://cdn.faire.com/fastly/994c99b48e982a8a0b93abb7d97fc0f951d2919b488bacc9f2651c4844508caa.jpeg",
    "https://cdn.faire.com/fastly/f53070bc5348c22fa4b317e0cbdb18949a0ed8c5e5c7e8aa09346d7b017b86af.jpeg",
    "https://cdn.faire.com/fastly/b7b3440ce169df40abe1ab16c5f7a9748c3c527ac2315890abc8b7966d75c2e9.jpeg",
  ],
  priceDollars: 6.5,
  description:
    'Make a bold statement with this modern Angle Cut Goblet, designed to bring elegance and artistry to any occasion. Featuring a sleek, slanted rim, these glasses offer a contemporary twist on classic drinkware while enhancing the sipping experience. The goblet, at 8.5" tall with a 12oz capacity, is ideal for red or white wine, cocktails, or even bubbly water, easily blending sophistication with functionality.',
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:08.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
